import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-readonly-input',
    templateUrl: './readonly-input.component.html',
    standalone: false
})
export class ReadonlyInputComponent extends BaseFormInput {
}
